import { render, staticRenderFns } from "./CopyTo.vue?vue&type=template&id=11249123"
import script from "./CopyTo.vue?vue&type=script&lang=js"
export * from "./CopyTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports